<template>
    <div class="soil-report-header-container">
        <div class="soil-report-header" :page="page_nbr">
            <div class="flexbox">
                <div class="flex p-l-25">
                    <div class="text-nowrap">
                        <div class="inline soil-rpt-header-label">Report Number:</div>
                        <div class="inline soil-rpt-header-data">{{ report_nbr }}</div>
                    </div>
                    <!-- div class="text-nowrap">
                        <div class="inline soil-rpt-header-label">Analysis Date:</div>
                        <div class="inline soil-rpt-header-data">{{ analysis_date }}</div>
                    </div -->
                    <div class="text-nowrap">
                        <div class="inline soil-rpt-header-label">Account Number:</div>
                        <div class="inline soil-rpt-header-data">{{ account.account_nbr }}</div>
                    </div>
                </div>

                <div class="flex text-center" style="height:75px">
                    <img :src="logo" style="max-width:300px;max-height:75px" />
                </div>

                <div class="flex text-right p-r-25">
                    <div class="inline text-left">
                        <div class="text-nowrap media-screen-hidden">
                            <div class="inline soil-rpt-header-label">Page</div>
                            <div class="inline soil-rpt-header-data">{{ page_nbr }}/{{ total_pages }}</div>
                        </div>

                        <div class="text-nowrap media-print-hidden">
                            <div class="inline soil-rpt-header-label">Pages</div>
                            <div class="inline soil-rpt-header-data">{{ total_pages }}</div>
                        </div>

                        <div class="text-nowrap">
                            <div class="inline soil-rpt-header-label">Report Date:</div>
                            <div class="inline soil-rpt-header-data">{{ report_date }}</div>
                        </div>

                        <div class="text-nowrap" v-for="copy_to in copy_tos">
                            <div class="inline soil-rpt-header-label">Copy To:</div>
                            <div class="inline soil-rpt-header-data">{{ copy_to }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flexbox" style="align-items:center">
                <div class="flex">
                    <div class="p-t-15" v-if="account">
                        <div>{{ account.account_nm }}</div>
                        <div>{{ account.contact_nm }}</div>
                        <div>{{ account.address1 }}</div>
                        <div v-if="account.address2">{{ account.address2 }}</div>
                        <div>{{ account.city }}, {{ account.state_cd }} {{ account.postal_cd }}</div>
                    </div>
                </div>

                <div class="flex text-center">
                    <div class="soil-rpt-header-data" v-for="(grower_line, line) in grower" v-if="line < 3">{{ grower_line }}</div>
                </div>

                <div class="flex"></div>
            </div>
        </div>
    </div>
</template>


<script type="text/ecmascript-6">
    export default{
        props: {
            page_nbr: { default: 1 },
            total_pages: { default: 1 },
            report_data: { default() { return {} }},
            copy_tos: { default() { return [] } },
            theme_applied: { default: false }
        },
        data () {
            return {

            }
        },
        computed: {
            report_nbr () {
                return this.report_data.report_nbr || 'XX-XXX-XXXX';
            },
            first_sample () {
                return this.report_data.samples && this.report_data.samples.length > 0 ? this.report_data.samples[0] : null
            },
            analysis_date () {
                return _.has(this.first_sample, ['Analysis Date', 'value']) ? moment(this.first_sample['Analysis Date'].value).format('MMM D, Y') : 'XXXX-XX-XX';
            },
            report_date () {
                return _.has(this.first_sample, ['Report Date', 'value']) ? moment(this.first_sample['Report Date'].value).format('MMM D, Y') : 'XXXX-XX-XX';
            },
            account () {
                return this.report_data.account || {
                    account_nbr: 'XXXXX',
                    account_nm: 'Account Name',
                    contact_nm: 'Contact Name',
                    address1: 'Address Line 1',
                    city: 'City',
                    state_cd: 'State',
                    postal_cd: 'XXXXX'
                }
            },
            logo () {
                return this.theme_applied && _.has(this.report_data,['custom_theme','logo_image_file'])
                    ? '/online_report_themes/logos/' + this.report_data.custom_theme.logo_image_file
                    : '/img/mwl-logo-sm.png';
            },
            grower () {
                return this.report_data.report_headers || ['XXXXX XXX XXXXXXXXXX'];
            }
        },
        methods: {

        },
        mounted () {

        }
    }
</script>



// WEBPACK FOOTER //
// ReportHeader.vue?0f79c50c